import { render } from "./AddScript.vue?vue&type=template&id=0a3a9df0"
import script from "./AddScript.vue?vue&type=script&lang=js"
export * from "./AddScript.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__